import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=4bf6e7aa&"
import script from "./CategoryPage.vue?vue&type=script&lang=ts&"
export * from "./CategoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports